import { gql } from '@apollo/client'

export const GET_REFUND_REQUEST_LIST = gql`
    query getRefundRequest($request_filter: RefundFilterInput!, $page: PageInput!) {
        getRefundRequest(request_filter: $request_filter, page: $page) {
            code
            success
            message
            total_count
            refund_requests {
                request_id
                request_code
                booking_id
                user_id
                request_date
                refund_details {
                    segment_id
                    booking_id
                    route_id
                    trip_id
                    travel_date
                    trip_price
                    cancelled_at
                    refund_amount
                    penalty_amount
                    policy_applied
                    policy_percent
                    refundable_base
                    hours_before_trip
                    trip_departure_time
                    route {
                        route_id
                        route_name {
                            en
                            ar
                        }
                    }
                    trip {
                        trip_id
                        trip_name {
                            en
                            ar
                        }
                        start_time
                        end_time
                    }
                    start {
                        location_id
                        stop_number
                        arrival_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    end {
                        location_id
                        stop_number
                        arrival_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                }
                status
                metadata
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`
